import { render } from "./ManualAttendanceApprovals.vue?vue&type=template&id=7cda5b41&scoped=true&ts=true"
import script from "./ManualAttendanceApprovals.vue?vue&type=script&lang=ts"
export * from "./ManualAttendanceApprovals.vue?vue&type=script&lang=ts"

import "./ManualAttendanceApprovals.vue?vue&type=style&index=0&id=7cda5b41&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/jahajibd.com/ia.jahajibd.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cda5b41"]])

export default __exports__